module.exports = __webpack_public_path__ + "img/Independent-Auditor-Report.4c0a0741.jpg";